import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useThemeContext } from '#contexts/ThemeContext';
import { useBreakpoints } from '#utils/breakpoint';
import { Box, makeStyles, Typography } from '@material-ui/core';
import { ArrowBackIos } from '@material-ui/icons';
import { boxShadow, colors } from '@swyft/ui';
import * as React from 'react';
export const BackButton = ({ disabled, handleBack }) => {
    const { iconButtons, isEmbed, primaryButtonText, isTouchDevice } = useThemeContext();
    const [showTitle, setShowTitle] = React.useState(false);
    const classes = useStyles({ showTitle })();
    const { isLessThanMd, isLessThanSm } = useBreakpoints();
    return (_jsxs(Box, { className: `${classes.backButton} ${disabled ? classes.backButtonDisabled : ''}`, my: 'auto', bgcolor: 'transparent', zIndex: 10, onClick: () => handleBack(), display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: isEmbed ? 'borderRadius' : 0, onMouseEnter: () => setShowTitle(true), onMouseLeave: () => setShowTitle(false), children: [_jsx(ArrowBackIos, { className: 'backIcon', style: { color: disabled ? colors.grey.DEFAULT : showTitle ? primaryButtonText : iconButtons } }), showTitle && !isLessThanMd && !isLessThanSm && (_jsx(Typography, { variant: isLessThanMd ? 'caption' : 'subtitle1', style: { color: primaryButtonText }, children: "Back" }))] }));
};
const useStyles = ({ showTitle }) => makeStyles((theme) => {
    const { isEmbed, primaryButtonBackground } = useThemeContext();
    return {
        backButtonDisabled: {
            visibility: 'hidden'
        },
        backButton: {
            cursor: 'pointer',
            boxShadow: boxShadow,
            backgroundColor: showTitle ? primaryButtonBackground : colors.white,
            padding: '0px!important',
            margin: 0,
            borderRadius: '0px 30px 30px 0px',
            transition: 'all .2s ease-in',
            position: 'fixed',
            [theme.breakpoints.down('sm')]: {
                left: 0,
                top: 110,
                width: 40,
                height: 50,
                borderRadius: '0px 28.8px 28.8px 0px',
                '& .backIcon': {
                    fontSize: 19
                }
            },
            [theme.breakpoints.up('md')]: {
                left: 0,
                top: 110,
                width: showTitle ? 92 : 48,
                height: 57.6,
                borderRadius: '0px 28.8px 28.8px 0px',
                '& .backIcon': {
                    fontSize: 19
                }
            },
            [theme.breakpoints.up('lg')]: {
                left: 0,
                top: 130,
                width: showTitle ? 153 : 80,
                height: 96,
                borderRadius: '0px 48px 48px 0px',
                '& .backIcon': {
                    fontSize: 32
                }
            },
            [theme.breakpoints.up('xl')]: {
                left: 0,
                top: 280,
                width: showTitle ? 153 : 80,
                height: 96,
                borderRadius: '0px 48px 48px 0px',
                '& .backIcon': {
                    fontSize: 32
                }
            }
        }
    };
});
